<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.userName" placeholder="账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getUsers">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="users" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="user_name" label="账号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="nickname" label="昵称" width="150"  sortable>
			</el-table-column>
			<el-table-column prop="last_login_time" label="登录时间"  sortable>
			</el-table-column>
			<el-table-column  prop="manager" label="管理员" width="100" >
		      <template slot-scope="scope" >	
			       <p>{{ scope.row.manager==1?'是':'否' }}</p>					
										
			   </template>
			</el-table-column>
			<el-table-column  prop="stop_flag" label="停用" width="100" >
			   <template slot-scope="scope">				
						  <p>{{ scope.row.stop_flag==1?'是':'否' }}</p>				
				</template>
			</el-table-column>
			<el-table-column label="操作" >
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="账号" prop="user_name">
					<el-input v-model="editForm.user_name" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="昵称" prop="nickname">
				     <el-input v-model="editForm.nickname" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input type="password" v-model="editForm.password" placeholder="" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="上次登录时间">
					<el-input placeholder="" :disabled="true" v-model="editForm.last_login_time" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="">					
					 <el-checkbox v-model="editForm.manager">管理员</el-checkbox>
					 <el-checkbox v-model="editForm.stop_flag">停用</el-checkbox>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getUserListPage,addUser,editUser, removeUser,batchRemoveUser } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
	export default {
		data() {
			return {
				filters: {
					userName: ''
				},
				users: [],
				total: 0,
				pageSize:20,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					user_name: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					],
				},
				//编辑界面数据
				editForm: {
					user_id: 0,
					user_name: '',
					nickname: '',
					last_login_time:'',
					password: '',
					manager: false,
					stop_flag:false
				},

				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			formatCheck: function (row, column) {
				return row.manager == 1 ? "true": "false";
			},
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getUsers();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getUsers();
			},
			//获取用户列表
			getUsers() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					userName: this.filters.userName,
					systype:3,
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getUserListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.userlist.total;
					         this.users = res.data.userlist.users;
					         this.listLoading = false;
                           
                         }
                         else{                           
                            
                              this.listLoading = false;

							
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
					
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )






			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,user_id: row.user_id,sys_type:3,Session:Session };


                   this.$http.jsonp(removeUser, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getUsers();
                           
                         }
                         else{                           
                              this.listLoading = false;
							  if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
                
				this.editForm.manager=this.editForm.manager>0?true:false;
				this.editForm.stop_flag=this.editForm.stop_flag>0?true:false;

				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.editFormVisible = true;
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				this.editForm = {
					user_id: 0,
					user_name: '',
					nickname: '',
					last_login_time:'',
					password: '',
					manager: false,
					stop_flag:false
				};

				
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["sys_type"] = "3";
							para["CurrentUserID"] = CurrentUserID;
							para["session"]=Session;

							

			   let userUrl=	addUser;			  
               if (this.formStatus==1)
			   {
                  userUrl=editUser;
			   }
                this.$http.jsonp(userUrl, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							    if (this.$refs['editForm'] !== undefined) {						
									this.$refs['editForm'].resetFields();
								}
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getUsers();
                           
                         }
                         else{                           
                             	this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.editLoading = false;	
                   }
           )

						});
					}
				});
			},
			
			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getUsers();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.user_id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,sys_type:3,Session:Session };


                   this.$http.jsonp(batchRemoveUser, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getUsers();
                           
                         }
                         else{                           
                               this.listLoading = false;
							   if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			
			this.getUsers();
		}
	}

</script>

<style scoped>
  .el_input_width{
	 width:220px; 
  }
</style>


// WEBPACK FOOTER //
// user.vue?7330b1f8